<template lang="pug">
.form-group
    label
      | {{ label }}
    vSelect(
      router-link,
      :value="value",
      :reduce="(option) => option.id",
      label="city",
      :multiple="multiple",
      :class="cssClass",
      @input="selection",
      @option:deselected="handleClear"
    )
</template>
  
  <script>
  import vSelect from "vue-select";
  export default {
    name: "CitySelect",
    components: { vSelect },
    props: {
      label: {
        type: String,
        default: "Villes",
      },
      value: {
        type: [Object, Array],
        default: null,
      },
      cssClass: {
        type: String,
        default: "form-select-control",
      },
      multiple: Boolean,
      citiesList: {
        type: Array,
        default: function () {
          return [];
        },
      },
     
    },
    computed: {
      cities() {
        return this.citiesList ;
      },
    },
    methods: {
      selection(val) {
        this.$emit("update:modelValue", val);
        this.$emit("city", val);
      },
      handleClear(val){
        this.$emit("deletecity", val);
      },
    },
    
  };
  </script>
  